<kp-map-modal>
    <section class="column">
        <section class="row baseline">
            <h3>Select location to add</h3>
            <button class="icon margin-left" (click)="requestClose()" (keydown.enter)="requestClose()">
                <img [src]="icons.close" />
            </button>
        </section>
        <ng-container *ngFor="let feature of data.features">
            <div
                class="selector"
                (click)="requestSelect(feature)"
                (keydown.enter)="requestSelect(feature)"
                *ngIf="!feature.properties.located && feature.properties.type == 'location'"
            >
                {{ feature.properties.name }}
            </div>
        </ng-container>
        <br />
    </section>
</kp-map-modal>
